// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner__spinner__I-pCA","medium":"Spinner__medium__fILgH","middle":"Spinner__middle__8EFOp","large":"Spinner__large__M8Oed"};